import { IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import { getUserProfile } from "../../../reducers/userProfileState";
import { useRef, useState } from "react";
import UserProfileMenu from "./UserProfileMenu";
import { useViewport } from "../../../hooks/others/useViewport";
import { USER_PROFILE_IMAGE_SIZES } from "../../../utils/constants/viewConstants";
import CircularImage from "../../common/containers/CircularImage";
import GrowingContainer from "../../common/containers/GrowingContainer";

const UserProfileMenuButton = () => {
    const userProfile = useSelector(getUserProfile);
    const imageSize = useViewport(USER_PROFILE_IMAGE_SIZES);

    const [menuOpen, setMenuOpen] = useState(false);

    const onClick = () => {
        setMenuOpen(true);
    }
    const closeMenu = () => {
        setMenuOpen(false);
    }

    const buttonRef = useRef();

    return (
        <>
            {
                !userProfile.empty &&
                <>
                    <div ref={buttonRef}>
                        <GrowingContainer>
                            <IconButton onClick={onClick} color="default">
                                <CircularImage imageUrl={userProfile.images.sm.url} size={imageSize} />
                            </IconButton>
                        </GrowingContainer>
                    </div>
                    <UserProfileMenu open={menuOpen} handleClose={closeMenu} anchor={buttonRef.current} userName={userProfile.name} />
                </>
            }
        </>
    )
}

export default UserProfileMenuButton;